import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';

interface ErrorMessageProps {
    errorMessage: string | undefined;
    showReturnButton?: boolean;
    title: string;
    translations: Record<string, string>;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
    errorMessage,
    showReturnButton = true,
    title,
    translations,
}) => (
    <>
        <Typography align="center" gutterBottom variant="h5" component="h2">
            {title}
        </Typography>
        {errorMessage && (
            <Typography align="center" variant="subtitle1" gutterBottom>
                {errorMessage}
            </Typography>
        )}
        {showReturnButton && (
            <Box mt={4}>
                <ButtonLink to="/" text={translations.GLOBAL_HOME_BUTTON} />
            </Box>
        )}
    </>
);
